module.exports = __webpack_public_path__ + "img/LONG-SLEEVE-TEE_FRONT_WHITE-BACK.d86920ec.jpg";